import { Component, AfterViewInit, Input, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  WizDatasource,
  WizDropdown,
  WizTextInput,
  WizTranslationInput,
  WizNumericInput,
  WizButton,
  WizValidationErrors,
  WizValidationContainerDirective,
  WizRadioGroup,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { Model } from './../../../model/model';
import { ChronocodeTemplateVO, TimeGapVO } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE, TIME_UNIT } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ChronocodeVO } from '@wizeoo/akm-common-lib';

/** Section de la vue de création de chronocodes dédiée à un niveau */
@Component({
  selector: 'chrono-level-group',
  templateUrl: './chrono-level-creation.group.html',
})
export class ChronoLevelCreationGroup implements AfterViewInit, OnDestroy {
  /** renderer complet */
  @ViewChild('mainGP', { read: ElementRef, static: false }) mainGP: ElementRef;
  /** Group container de la regexp */
  @ViewChild('vgDetail', { read: ElementRef, static: false }) vgDetail: ElementRef;

  @ViewChild('btShowHide', { read: WizButton, static: false })
  btShowHide: WizButton; /** Bouton pour montrer/masquer le panneau */
  @ViewChild('btnSubLevel', { read: WizButton }) btnSubLevel: WizButton; /** bouton d'ajout de niveau inférieur */

  /** Dropdown de saisie de durée */
  @ViewChild('ddlTimeGap', { read: WizDropdown, static: false }) ddlTimeGap: WizDropdown;
  /** Input nombre d'enfants */
  @ViewChild('niChildNumber', { read: WizNumericInput, static: false }) niChildNumber: WizNumericInput;
  /** regexp de nommage */
  @ViewChild('tiRegex', { read: WizTextInput, static: false }) tiRegex: WizTextInput;
  /** Dropdown de saisie de durée */
  @ViewChild('ddlRegexIndexFormat', { read: WizDropdown, static: false }) ddlRegexIndexFormat: WizDropdown;
  /** Input de saisie label du level */
  @ViewChild('tiLabel', { read: WizTranslationInput }) tiLabel: WizTranslationInput;
  /** Dropdown de jour de début de la semaine */
  @ViewChild('ddlWeekStart', { read: WizDropdown, static: false }) ddlWeekStart: WizDropdown;
  /** choix de nommage des semaines */
  @ViewChild('rgWeekName', { read: WizRadioGroup, static: false }) rgWeekName: WizRadioGroup;

  /** Zone de validation du timeGap */
  @ViewChild('hgPeriodDefinition', { read: WizValidationContainerDirective, static: false })
  private hgPeriodDefinition: WizValidationContainerDirective;

  @ViewChild('btShowHidePeriods', { read: WizButton, static: false }) btShowHidePeriods: WizButton; // Bouton pour montrer/masquer le détail des undefined

  /** Le template de niveau manipulé */
  @Input() public chroTemplate: ChronocodeTemplateVO;

  public panelVisible: boolean = false; /** Visibilité du panneau */
  public contentVisible: boolean = true; /** Visibilité du contenu */
  public detailVisible: boolean = false; /** Visibilité du détail */

  public isLevelUndefined: boolean = false; /** Les éléments du niveau sont de nature "undefined" */
  public isTimeGapWeek: boolean = false; /** les élements du niveau on un découpage par semaine */
  public isWeekDefaultName: boolean = true; /** flag indiquant que le choix par défaut du nommage des semaines */
  public canAddSubLevel: boolean = false; /** flag indiquant si un nouveau niveau peut être ajouter */

  /** Datasource de la liste de timegaps  pour les enfants */
  public timegapDS: WizDatasource<TimeGapVO> = new WizDatasource<TimeGapVO>([])
    .setSortFields([{ property: 'temporalWeightSort', way: 'desc', numeric: true }])
    .setFilter(this.filterTimegaps.bind(this))
    .build();

  /** Datasource de la liste des jours pour le début de la semaine */
  public weekStartDS: WizDatasource<any> = new WizDatasource<any>(ViewData.getInstance().fakeWeekStartDay)
    .setSortFields([{ property: 'code', way: 'desc' }])
    .setSelectedItems([ViewData.getInstance().fakeWeekStartDay[0]]) // on sélectionne la premièer valeur, TODO on pourra calculer la valeur selon la locale
    .build();

  /** Datasource des formats d'index pour la génération de codes */
  public indexFormatDS: WizDatasource<any> = new WizDatasource<any>(ViewData.getInstance().indexFormatList)
    .setSelectionMode('single')
    .build();

  /* ################################################
               cycle de vue
   ################################################ */

  constructor(public elementRef: ElementRef) {}

  public ngAfterViewInit(): void {
    this.tiRegex.wizRestrict = ViewData.CODE_REGEXP;
    this.timegapDS.setSource(Model.getInstance().timegapList);

    WizEventManager.addListener(this, this.mainGP, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onChange);
    WizEventManager.addListener(this, this.btShowHide, WIZ_EVENT_TYPE.CLICK, this.showHidePanel);

    WizEventManager.addListener(this, this.ddlWeekStart, WIZ_EVENT_TYPE.CHANGE, this.onWeekStartDateChange);
    WizEventManager.addListener(this, this.rgWeekName, WIZ_EVENT_TYPE.CHANGE, this.onWeekNameChooserChange);
    WizEventManager.addListener(this, this.btnSubLevel, WIZ_EVENT_TYPE.CLICK, this.askForNSubLevel);
    // gestion des périodes customs
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.CHRONO_DATE_CHANGE, this.alterChildDates);
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.DELETE_CHRONO_TEMPLATE_ITEM, this.deleteChild);

    setTimeout(() => {
      this.feed();
      this.manageComponents();
    }, 0);
  }

  /**
   * Suppression d'écouteurs
   */
  public ngOnDestroy(): void {
    WizEventManager.removeListener(this, this.mainGP, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.btShowHide, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.ddlWeekStart, WIZ_EVENT_TYPE.CHANGE);
    WizEventManager.removeListener(this, this.rgWeekName, WIZ_EVENT_TYPE.CHANGE);
    WizEventManager.removeListener(this, this.btnSubLevel, WIZ_EVENT_TYPE.CLICK);

    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.CHRONO_DATE_CHANGE);
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.DELETE_CHRONO_TEMPLATE_ITEM);
  }

  /** Alimentation des données */
  private feed(): void {
    this.tiLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.chroTemplate.labelVO);
    this.indexFormatDS.select([ViewData.getInstance().indexFormatList[0]]);
    this.ddlTimeGap.wizDataProvider = this.timegapDS;
  }

  /** Gestion des composants */
  private manageComponents(): void {
    this.detailVisible = !!this.chroTemplate.timeGapCode;
    this.isTimeGapWeek = this.chroTemplate.timeGapCode === TIME_UNIT.WEEK;
    this.isLevelUndefined = this.chroTemplate.timeGapCode === TIME_UNIT.UNDEFINED;
    this.canAddSubLevel = this.chroTemplate.hasTimeGap && !this.isEndOfTime() && !this.chroTemplate.hasChild; // TODO check pas day et parent.maxtime/ undefined > 1
  }

  /** le timeGap choisi ne permet plus de sous-niveaux */
  private isEndOfTime(): boolean {
    let result: boolean = false;
    if (this.chroTemplate.timeGapCode === TIME_UNIT.DAY) {
      result = true;
    } else if (this.chroTemplate.timeGapCode === TIME_UNIT.UNDEFINED) {
      if (this.chroTemplate.maxTimeWeight <= 1) {
        // en cas de gestion custom, possible période à 1
        result = true;
      }
      const parentTime = this.chroTemplate.parentTemplate.maxTimeWeight;
      const maxDay: number = Math.ceil(parentTime / this.niChildNumber.wizNumber);
      if (maxDay <= 1) {
        result = true;
      }
    }
    return result;
  }

  /* ################################################
                 interactions
   ################################################ */

  /**
   * à la sélection de la date de début des semaines
   * on mets à jour la date de debut des semaines
   * @param e wizEvent
   */
  public onWeekStartDateChange(e: WizEvent): void {
    const weekStart = e.value ? e.value[0] : null;
    if (weekStart) {
      Model.getInstance().businessUnitEngine.currentBU.firstDayOfWeek = weekStart.value;
    }
  }

  /** mise à jour du flag indiquant le nommage des semaines */
  public onWeekNameChooserChange(e: WizEvent = null): void {
    this.isWeekDefaultName = !e || e.value === '01';
    this.onRegexChange();
  }

  /** demande d'ajout d'un niveau */
  public askForNSubLevel(e: WizEvent): void {
    WizEventManager.dispatchEvent(
      this.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.CHRONO_LEVEL_ACTIVATE, this.chroTemplate.level)
    );
    this.canAddSubLevel = false; // on le force pour éviter un refresh
  }

  /**
   * affichage ou non du champ de la regexp
   * le champ de saisi de la regexp n'est pas visible si la temporalité est le semaine
   * et que l'utilisateur choisi le nom par défaut
   * @return boolean
   */
  public regexpVisible(): boolean {
    this.isTimeGapWeek = !!this.chroTemplate.timeGapCode && this.chroTemplate.timeGapCode === TIME_UNIT.WEEK;
    if (this.isTimeGapWeek) {
      return !this.isWeekDefaultName;
    }
    return true;
  }

  /**
   * Fonction de filtre des timegaps par rapport au parent
   * @param item Elément testé pour le filtre
   */
  private filterTimegaps(item: TimeGapVO): boolean {
    const maxTemporalWeight: number = this.chroTemplate.maxTimeWeight;
    let result = false;
    if (maxTemporalWeight > 1) {
      // A 1, on est déjà au niveau jour au dessus, on ne peut plus découper
      result = item && (!item.temporalWeight || !maxTemporalWeight || item.temporalWeight < maxTemporalWeight);
    }
    return result;
  }

  /** Alimentation des shortCodes */
  private showHidePanel(e: WizEvent): void {
    this.contentVisible = !this.contentVisible;
    this.btShowHide.wizIcon = this.contentVisible ? 'reduce' : 'add';
  }

  /**
   * Modification
   * @param e Evenement model change
   */
  private onChange(e: WizEvent): void {
    const preventUpdateEvent: boolean = false;
    switch (e.component) {
      case this.ddlTimeGap:
        this.chroTemplate.timeGapCode = this.ddlTimeGap.selectedItem ? this.ddlTimeGap.selectedItem.code : null;
        this.tiRegex.wizValue = this.ddlTimeGap.selectedItem ? this.ddlTimeGap.selectedItem.code : null;
        this.onRegexChange();
        break;
      case this.tiRegex:
      case this.ddlRegexIndexFormat:
        this.onRegexChange();
        break;
      case this.tiLabel:
        this.chroTemplate.labelVO.updateTranslationEntry(e.value);
        break;
      case this.niChildNumber:
        this.chroTemplate.requestedChildren = this.niChildNumber.wizNumber;
        this.chroTemplate.customPeriods = null;
        this.manageUndefinedDetail();
        break;
    }
    if (!preventUpdateEvent) {
      this.manageComponents();
      WizEventManager.dispatchEvent(this.mainGP, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    }
  }

  /** Rafraichissement appelé depuis la vus */
  public refresh(): void {
    this.manageComponents();
  }

  /**
   * Changement de regex
   */
  public onRegexChange(): void {
    this.isTimeGapWeek = !!this.chroTemplate.timeGapCode && this.chroTemplate.timeGapCode === TIME_UNIT.WEEK;
    if (this.isTimeGapWeek && this.isWeekDefaultName) {
      const indexFormat: string = 'DefaultWeek';
      const regex: string = ViewData.getInstance().weeksPrefix;
      this.chroTemplate.codeRegex = regex + '[P_INDEX:{"format":"' + indexFormat + '"}]';
    } else {
      const indexFormat: string = this.ddlRegexIndexFormat.selectedItem
        ? this.ddlRegexIndexFormat.selectedItem.code
        : '1';
      const regex: string = this.tiRegex.wizValue ? this.tiRegex.wizValue : '';
      this.chroTemplate.codeRegex = regex + '[P_INDEX:{"format":"' + indexFormat + '"}]';
    }
    this.manageUndefinedDetail();
  }

  /**
   * Validation des données
   * @param e : Evenement clic
   */
  public validationCheck(): WizValidationErrors {
    // Vérification de la saisie
    let result: WizValidationErrors = [];

    result = this.hgPeriodDefinition.check(true, true);
    return result;
  }

  /** demande de suppression de ce niveau */
  public deleteLevel(): void {
    // console.log('deleteLevel');
    WizEventManager.dispatchEvent(
      this.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.CHRONO_LEVEL_DEACTIVATE, this.chroTemplate.level)
    );
  }

  /* ################################################
        gestion spécifique des lignes undefined
   ################################################ */

  public showUndefinedDetail: boolean = false; // affichage ou pas du détail des lignes en cas de level undefined

  public undefinedPeriods: ChronocodeVO[] = []; // les périodes customs en cas de undefined, pour update

  public manageUndefinedDetail(): void {
    if (!!this.chroTemplate.customPeriods) {
      // les périodes on été générées, mais modif, on rince
      this.chroTemplate.resetCustomPeriods();
      this.undefinedPeriods = [];
      WizEventManager.dispatchEvent(
        this.elementRef,
        new AlkEvent(ALK_EVENT_TYPE.CHRONO_LEVEL_DEACTIVATE, this.chroTemplate.level + 1)
      );
      this.toggleShowEditDetail(true);
    }
  }

  /** affichage du détail des périodes pour customisation. génération si nécessaire */
  public toggleShowEditDetail(forceClose: boolean = false): void {
    this.showUndefinedDetail = forceClose ? false : !this.showUndefinedDetail;
    this.btShowHidePeriods.wizIcon = this.showUndefinedDetail ? 'reduce' : 'add';

    if (this.showUndefinedDetail) {
      if (!this.chroTemplate.customPeriods) {
        this.chroTemplate.buildUndefinedPeriods();
        this.undefinedPeriods = this.chroTemplate.customPeriods;
      }
    }
  }

  /**
   * interception d'une demande de suppression d'un enfant chronocode
   * e.data = chronocodeVO
   */
  public deleteChild(e: AlkEvent): void {
    const chrono: ChronocodeVO = e.data;
    const previous: ChronocodeVO = chrono.template.deleChrono(chrono);
    this.undefinedPeriods = this.chroTemplate.customPeriods; // refresh de la collection
    // dispatch pour gestion par le parent chronoLevelCreationGroup
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_CHRONO_TEMPLATE_ITEM, previous));
  }

  /**
   * mise à jour des dates d'un chrono
   * @param e alkevent data[0] le chrono modifié
   * data[1] true si startDate, false si EndDate
   */
  public alterChildDates(e: AlkEvent): void {
    const chrono: ChronocodeVO = e.data[0];
    const other: ChronocodeVO = chrono.template.alterChronoDate(chrono, e.data[1]); // va aussi recalculer le maxWeight
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_CHRONO_TEMPLATE_ITEM, other));
    this.manageComponents(); // l'amplitude minimale n'est peut-être plus valide pour ajouter un niveau
    WizEventManager.dispatchEvent(
      this.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.CHRONO_LEVEL_DEACTIVATE, this.chroTemplate.level + 1)
    );
  }
}
